var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKey = function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M4.667 9.077q-.449 0-.762-.315A1.04 1.04 0 0 1 3.59 8q0-.449.315-.762.314-.315.762-.315.447 0 .762.315.315.314.314.762 0 .447-.314.762-.315.315-.762.315m0 2.59q-1.526 0-2.596-1.071Q1 9.524 1 8q0-1.526 1.07-2.596t2.597-1.071q1.071 0 1.938.553a3.7 3.7 0 0 1 1.323 1.447h6.002L15.596 8l-2.564 2.55-1.237-.928-1.27.942-1.3-.898H7.927a3.7 3.7 0 0 1-1.323 1.444 3.5 3.5 0 0 1-1.938.556m0-1q.959 0 1.66-.58.702-.58.917-1.42h2.295l.96.664 1.302-.953 1.132.865L14.177 8l-.667-.667H7.244a2.66 2.66 0 0 0-.917-1.42q-.701-.58-1.66-.58-1.1 0-1.884.783A2.57 2.57 0 0 0 2 8q0 1.099.783 1.883.784.783 1.884.783"
  })));
};
export default SvgIconKey;